import { lazy } from "react";

export { APPLICATION_LIST_PATH } from "./path";
export const ApplicationListPage = lazy(() => import("./page"));
export { ToApplicationList } from "./to-application-list";
